export default "__VITE_ASSET__C0Tyq61l__"